import { render, staticRenderFns } from "./commonLabelDialog.vue?vue&type=template&id=1c684668&scoped=true"
import script from "./commonLabelDialog.vue?vue&type=script&lang=js"
export * from "./commonLabelDialog.vue?vue&type=script&lang=js"
import style0 from "./commonLabelDialog.vue?vue&type=style&index=0&id=1c684668&prod&scoped=true&lang=css"
import style1 from "./commonLabelDialog.vue?vue&type=style&index=1&id=1c684668&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c684668",
  null
  
)

export default component.exports